// tslint:disable:max-line-length

import React from 'react';

export const ObjectCompleteInspection = (props: React.SVGProps<SVGSVGElement>) => {
  return (
    <svg viewBox="0 0 16 16" {...props}>
      <path d="M11.5,3c0-0.5-0.5-1-1-1h-1V1.5C9.5,0.7,8.8,0,8,0S6.5,0.7,6.5,1.5V2h-1c-0.5,0-1,0.5-1,1v1h7V3z M8.5,2h-1V1.5 C7.5,1.2,7.7,1,8,1s0.5,0.2,0.5,0.5V2z" />
      <path d="M14.2,3h-1.8v2h-9V3H1.8C1.6,3,1.5,3.1,1.5,3.2v12.5c0,0.1,0.1,0.2,0.2,0.2h12.5c0.1,0,0.2-0.1,0.2-0.2V3.2 C14.5,3.1,14.4,3,14.2,3z M7.6,12.7l-1.1,1.1l-1.1-1.1l-1.5-1.5L5,10.1l1.5,1.5L11,7c0,0,1.1,1.2,1.1,1.1L7.6,12.7z" />
    </svg>
  );
};
